import request from './request';

const galleryService = {
  getAll: (params) =>
    request.get('dashboard/galleries/storage/files', { params }),
  // `config` can include `onUploadProgress` to report upload progress
  upload: (data, config = {}) => request.post('dashboard/galleries', data, config),
  delete: (params) =>
    request.post('dashboard/galleries/storage/files/delete', {}, { params }),
};

export default galleryService;
